import sample_1 from './sample1.jpeg';

export const gerustbauerImpressions = {
    sample_1,
};
